"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorLinkComponentInstance = exports.AnchorLinkComponent = void 0;
const app_1 = require("app");
class AnchorLinkComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = "a[href*='#']";
    }
    BeforeInit() {
        this.el.forEach(item => {
            item.addEventListener('click', function (ev) {
                const href = this.getAttribute('href');
                const hashPosition = href.indexOf('#');
                if (hashPosition === -1) {
                    return;
                }
                const hash = href.slice(hashPosition);
                if (hash.indexOf('/') !== -1) {
                    return;
                }
                document.dispatchEvent(new CustomEvent('anchor-link:click', { detail: { hash } }));
                app_1.scrollService.GoToAnchor(hash, ev);
            });
        });
    }
}
exports.AnchorLinkComponent = AnchorLinkComponent;
exports.anchorLinkComponentInstance = new AnchorLinkComponent();
